import ApiClient from "../helpers/ApiClient";
import useSWR from "swr";

const fetcher = (url) => ApiClient.get(url).then((res) => res.data?.data);

// Dashboard
export const useRfidDashboard = () => {
  return useSWR("/rfid/dashboard", fetcher, { revalidateOnFocus: true });
};

// Settings & Config
export const useRfidConfig = () => {
  return useSWR("/rfid/config", fetcher, { revalidateOnFocus: false });
};

export const saveRfidConfig = async (data) => {
  return await ApiClient.post("/rfid/config", data);
};

export const testRfidConnection = async (data) => {
  return await ApiClient.post("/rfid/test-connection", data);
};

// Locks & Mapping
export const useRfidLocks = () => {
  return useSWR("/rfid/locks", fetcher, { revalidateOnFocus: true });
};

export const syncRfidLocks = async () => {
  return await ApiClient.post("/rfid/locks/sync", {});
};

export const mapRfidLock = async ({ rfid_lock_id, room_id, building_no, floor_no }) => {
  return await ApiClient.post("/rfid/locks/map", {
    rfid_lock_id,
    room_id,
    building_no,
    floor_no
  });
};

export const unmapRfidLock = async (mapId) => {
  return await ApiClient.delete(`/rfid/locks/map/${mapId}`);
};

export const setRfidLockSector = async (lockId, sector) => {
  return await ApiClient.post(`/rfid/locks/${lockId}/set-sector`, { sector });
};

// Cards & Operations
export const useRfidCards = (params = {}) => {
  const query = new URLSearchParams();
  if (params.status) query.append("status", params.status);
  if (params.room_id) query.append("room_id", params.room_id);
  if (params.booking_id) query.append("booking_id", params.booking_id);
  if (params.search) query.append("search", params.search);
  if (params.page) query.append("page", params.page);
  if (params.per_page) query.append("perPage", params.per_page);

  const qs = query.toString();
  return useSWR(`/rfid/cards${qs ? `?${qs}` : ""}`, fetcher, { revalidateOnFocus: true });
};

export const issueRfidCard = async (cardData) => {
  return await ApiClient.post("/rfid/cards/issue", cardData);
};

export const extendRfidCard = async ({ card_id, new_valid_until }) => {
  return await ApiClient.post("/rfid/cards/extend", { card_id, new_valid_until });
};

export const revokeRfidCard = async (cardId, reason = "Manual Revocation") => {
  return await ApiClient.post(`/rfid/cards/${cardId}/revoke`, { reason });
};

export const replaceLostRfidCard = async ({ lost_card_id, new_card_number, new_card_uid, issuing_method }) => {
  return await ApiClient.post("/rfid/cards/replace-lost", {
    lost_card_id,
    new_card_number,
    new_card_uid,
    issuing_method
  });
};

export const useRfidOperations = (params = {}) => {
  const query = new URLSearchParams();
  if (params.page) query.append("page", params.page);
  if (params.per_page) query.append("perPage", params.per_page);

  const qs = query.toString();
  return useSWR(`/rfid/operations${qs ? `?${qs}` : ""}`, fetcher, { revalidateOnFocus: true });
};

// Front-Desk / Booking integration
export const prepareCheckInRfid = async (bookingId) => {
  return await ApiClient.get(`/rfid/bookings/${bookingId}/prepare`);
};

export const handleCheckoutRfid = async (bookingId) => {
  return await ApiClient.post(`/rfid/bookings/${bookingId}/checkout`, {});
};
